export default __webpack_public_path__ + "static/prob4-b0cdf274ab3df7277c2ec959bc240ced.png";